export default {
  cenqCollection: [],
};
